import styled from 'styled-components';

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${(props) => props.objectFit || 'none'}
`;
